import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import FacilitiesListComponent from 'containers/FacilitiesList';
import { section } from '../decorators';
import stylesGlobal from '../../../theme/facility-globals.scss';
import styles from './FacilitiesList.scss';

const FacilitiesList = ({ children, isEditable }) => {
  const [headerText] = React.Children.toArray(children);

  return (
    <div className={`${stylesGlobal.section} ${stylesGlobal.sectionNoPadBtm}`}>
      <Container>
        <Row>
          <Col md={12} sm={24} className={`color-primary-foreground ${styles.title}`}>
            {headerText}
          </Col>
          <Col md={12} sm={24}>
            <FacilitiesListComponent isEditable={isEditable} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

FacilitiesList.propTypes = {
  children: PropTypes.node.isRequired,
  isEditable: PropTypes.bool,
};

export default section(
  { name: 'Facilities List', category: 'Locations', deprecated: true },
  {
    subsections: [
      {
        accepts: ['ContentBox',
          'Coupon',
          'DirectionsText',
          'MapboxMapAllFacilities',
          'MapboxMapOneFacility',
          'HeaderText',
        ],
      },
    ],
    defaults: [
      ['HeaderText', {
        rawContentState: {
          blocks: [
            {
              key: 'db2mm',
              text: 'Self Storage Locations',
              type: 'header-one',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
            },
          ],
          entityMap: {},
        },
      }],
    ],
  },
)(FacilitiesList);
